import * as CONFIG from "@/components/config.js";

export const domainTypeMixin = {
  data: () => ({
    domain: CONFIG.serwis,
    travelOne: "travelone.pl",
    skiOne: "skione.pl",
  }),
  methods: {
    getDomainType(t, s) {
      // e.g. getDomainType('travelone', 'skione')
      //      getDomainType('travelone', '')
      let tOne = t + ".pl";
      let sOne = s + ".pl";

      if (tOne == this.domain || sOne == this.domain) {
        return true;
      } else if (tOne == this.domain && s == "") {
        return true;
      } else if (sOne == this.domain && t == "") {
        return true;
      } else {
        return false;
      }
    },
  },
};
